import { FormProvider, useForm } from "react-hook-form";
import { toast } from "react-toastify";
import ModalComponent from "../../../../../components/modals/ModalFormComponent";
import { useAddProductRequest } from "../../../../../services/payment-setup.service";
import ProductsStep from "./steps/ProductsStep";
import { PaymentSetupFormValues, emptyProduct } from "./helpers";

interface AddProductsModalProps {
	open: boolean;
	onClose: () => void;
	setupId: number;
	tier: string;
	companyName: string;
}

const AddProductsModal = ({
	open,
	onClose,
	setupId,
	tier,
	companyName,
}: AddProductsModalProps) => {
	// ProductsStep reads `products` and `companyName` from the shared form shape
	const methods = useForm<PaymentSetupFormValues>({
		defaultValues: {
			companyName,
			products: [{ ...emptyProduct, destinationDetails: { ...emptyProduct.destinationDetails } }],
		} as Partial<PaymentSetupFormValues>,
		mode: "onTouched",
	});
	const { mutate: addProductRequest, isLoading } = useAddProductRequest();

	const onSubmit = (values: PaymentSetupFormValues) => {
		addProductRequest(
			{ id: setupId, payload: { tier, products: values.products } },
			{
				onSuccess: () => {
					toast.success("Product request submitted for review");
					onClose();
				},
			},
		);
	};

	return (
		<ModalComponent open={open} title="Add products" width={900} handleClose={onClose}>
			<FormProvider {...methods}>
				<p className="text-xs text-gray-500 mb-5">
					Each new product is reviewed by the provider before it's enabled.
				</p>
				<ProductsStep requireAtLeastOne hideHeading />
				<div className="flex justify-end gap-3 mt-8">
					<button
						type="button"
						onClick={onClose}
						className="h-12 px-6 border border-gray-300 rounded-lg text-sm text-gray-600"
					>
						Cancel
					</button>
					<button
						type="button"
						onClick={methods.handleSubmit(onSubmit)}
						disabled={isLoading}
						className="bg-primary-mango text-white h-12 px-6 rounded-lg text-sm disabled:opacity-50"
					>
						{isLoading ? "Submitting..." : "Submit products"}
					</button>
				</div>
			</FormProvider>
		</ModalComponent>
	);
};

export default AddProductsModal;
